import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserProfiles: (state, action) => {
      state.userProfiles = action.payload;
    },
    setEmployee: (state, action) => {
      state.employee = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setUserProfiles, setEmployee } = userSlice.actions;

export default userSlice.reducer;
